// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__j4BJq","colMin":"styles_colMin__1BBEY"};